import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
@Component({
  selector: 'app-audit-log',
  template: `
    <p class="audit-log-item-type">Type: <b>{{auditLog.type.split('_').join(' ') | titlecase}}</b></p>
    <p *ngIf="auditLog.foreignAccountId" class="audit-log-item-foreign-account-id">
      Distribution account id: <b>{{auditLog.foreignAccountId}}</b>
    </p>
    <p *ngIf="auditLog.request" class="audit-log-item-request">{{auditLog.request | json}}</p>
    <p class="audit-log-item-performed-by">Performed by: <b>{{auditLog.performedBy}}</b></p>
    <p class="audit-log-item-performed-at">Performed at:
      <b>{{auditLog.performedAt.valueOf() * 1000 | date: 'dd/MM/yyyy HH:mm' }}</b>
    </p>
  `,
  styleUrls: ['./audit-log.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditLogComponent implements OnInit {

  @Input() auditLog!: any;
  constructor() { }

  ngOnInit(): void {
  }

}
